import { toast } from "react-toastify";

import { useMonthlyPayment } from "app/hooks/checkout/useMonthlyPayment";
import { useCartContext } from "app/providers/CartProvider";
import { useStandardProductContext } from "app/providers/StandardProductProvider";
import { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { useSearchParams } from "react-router-dom";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import StandardProductModalDialog from "shared/ui/modal/standard-product-modal/StandardProductModalDialog";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { StandardProductOptionsFooterMobile } from "./components/StandardProductOptionsFooterMobile";
import { StandardProductOptionsFooterNormal } from "./components/StandardProductOptionsFooterNormal";

const StandardProductOptionsFooter = ({}) => {
  const { store: standardProductStore, actions } = useStandardProductContext();
  const cartContext = useCartContext();
  const { addCartStandardProduct, updateCartStandardProduct, getCart } =
    cartContext;

  const showExtraPriceText =
    standardProductStore?.selectedStandardProductCategory?.code ===
      "glasreiniger" ||
    standardProductStore?.selectedStandardProductCategory?.code ===
      "cadeaukaart" ||
    standardProductStore?.selectedStandardProductCategory?.code === "verfset";

  const [searchParams] = useSearchParams();
  const editableProductIndex = searchParams.get("stdProductIndex");
  const calculateTotalAmount = (
    product: CategoryStandardProduct | undefined,
  ) => {
    const price = product?.price || 0;
    const amount = product?.amount || 0;
    return price * amount;
  };

  const totalStdAmount = useMemo(() => {
    return calculateTotalAmount(standardProductStore?.selectedStandardProduct);
  }, [standardProductStore?.selectedStandardProduct]);
  const { data } = useMonthlyPayment(totalStdAmount);
  const monthlyPayment = data?.monthlyPayment;

  const canProceed = () => {
    const cart = getCart();
    if (cart.products.length) {
      toast.info(
        `Je kan dit product niet toevoegen aan de winkelwagen, omdat je al ${
          cart.products.length === 1 ? "een deur" : "meerdere deuren"
        } hebt toegevoegd.`,
      );
      return false;
    }

    return true;
  };

  const isMonthlyPaymentAvailable = () => {
    return totalStdAmount >= 250 && totalStdAmount <= 10000;
  };

  const addStandardProductToCart = () => {
    if (!standardProductStore.selectedStandardProduct) {
      return;
    }
    if (!canProceed()) return;

    if (editableProductIndex) {
      const index = parseInt(editableProductIndex);
      updateCartStandardProduct(
        index,
        standardProductStore.selectedStandardProduct,
      );
      setIsOpen(true);
      return;
    }
    addCartStandardProduct(standardProductStore.selectedStandardProduct);
    setIsOpen(true);
  };
  const footersGridElement = document.getElementById("footersGridElements");
  const [isOpen, setIsOpen] = useState(false);
  return standardProductStore.selectedStandardProduct ? (
    <>
      <div>
        <StandardProductModalDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          totalPrice={getFormattedPrice(
            standardProductStore.selectedStandardProduct.price *
              (standardProductStore.selectedStandardProduct.amount || 1),
          )}
          product={standardProductStore.selectedStandardProduct}
          monthlyPayment={monthlyPayment ?? 0}
        />

        {footersGridElement &&
          createPortal(
            <footer className="gg-fixed gg-bottom-0 gg-left-0 gg-z-10 gg-mx-auto gg-hidden gg-w-full lg:gg-block">
              <StandardProductOptionsFooterNormal
                showExtraPriceText={showExtraPriceText}
                monthlyPayment={monthlyPayment}
                isMonthlyPaymentAvailable={isMonthlyPaymentAvailable}
                addStandardProductToCart={addStandardProductToCart}
              />
            </footer>,
            footersGridElement,
          )}

        {footersGridElement &&
          createPortal(
            <footer className="gg-container gg-sticky gg-bottom-0 gg-mx-auto">
              <div className="gg-fixed gg-bottom-0 gg-left-0 gg-z-10 gg-order-last gg-mx-auto gg-w-full lg:gg-hidden">
                <StandardProductOptionsFooterMobile
                  showExtraPriceText={showExtraPriceText}
                  monthlyPayment={monthlyPayment}
                  isMonthlyPaymentAvailable={isMonthlyPaymentAvailable}
                  addStandardProductToCart={addStandardProductToCart}
                />
              </div>
            </footer>,
            footersGridElement,
          )}
      </div>
    </>
  ) : (
    <></>
  );
};
export default StandardProductOptionsFooter;
